import React, { useState } from "react";
import "../Styling/Navi1OnlineTest.css";

const Navi1OnlineTests = () => {
  const [tests, setTests] = useState([
    { name: "CBT Online Test", attempted: true, passed: false },
    { name: "PI Test", attempted: true, passed: true },
    { name: "PLI Test", attempted: true, passed: false },
  ]);

  const toggleSwitch = (index, field) => {
    const updated = [...tests];
    updated[index][field] = !updated[index][field];
    setTests(updated);
  };

  const getResult = (test) => {
    if (!test.attempted) return "Pending";
    if (test.passed) return "Pass";
    return "Fail";
  };

  return (
    <div className="Navi1-online-test-container">
      <h1 className="section-title">Online tests</h1>

      <table className="onlinetable">
        <thead>
          <tr>
            <th>Test Name</th>
            <th>Attempted</th>
            <th>Passed</th>
            <th>Result</th>
          </tr>
        </thead>

        <tbody>
          {tests.map((test, index) => {
            const result = getResult(test);

            return (
                
              <tr key={index}>
                <td>{test.name}</td>

                <td>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={test.attempted}
                      onChange={() => toggleSwitch(index, "attempted")}
                    />
                    <span className="slider"></span>
                  </label>
                </td>

                <td>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={test.passed}
                      onChange={() => toggleSwitch(index, "passed")}
                    />
                    <span className="slider"></span>
                  </label>
                </td>

                <td>
                  <span className={`result-badge ${result.toLowerCase()}`}>
                    {result}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Navi1OnlineTests;